"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomerCreditAccount = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var react_query_1 = require("react-query");
var api_1 = require("../apps/returns/api");
var useCustomerCreditAccount = function (options) {
    var query = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query {\n      account {\n        creditAccount {\n          available_balance\n        }\n      }\n    }\n  "], ["\n    query {\n      account {\n        creditAccount {\n          available_balance\n        }\n      }\n    }\n  "])));
    return (0, react_query_1.useQuery)(['customerCreditAccount'], function () { return (0, api_1.getSublessAPIClient)().request(query); }, options);
};
exports.useCustomerCreditAccount = useCustomerCreditAccount;
var templateObject_1;
